import * as React from 'react';
import { Collapse } from 'components/common';
import { localize } from 'core/localization';
import { objectToArray } from 'utils/object';

import {
  SectionText,
  SectionItem,
  Header,
  Footer,
  StatusText,
  QuestionList
} from '../SectionTreeNode/SectionTreeNode.styled';

type PoolTreeNodeProps = {
  title: string;
  affectsProgress?: boolean;
  children: any;
  questionsForPool: any[];
  isCourseProgress: boolean;
  answeredPoolQuestionsCount: number;
  shouldSubmitAllQuestions: boolean;
};

export default class PoolTreeNode extends React.Component<PoolTreeNodeProps> {
  toggleIsExpanded = () => {
    this.setState(() => ({
      isExpanded: true
    }));
  };

  render() {
    const {
      title,
      children,
      questionsForPool,
      isCourseProgress,
      shouldSubmitAllQuestions,
      answeredPoolQuestionsCount
    } = this.props;

    const correctlyAnsweredQuestionsInSection = objectToArray(questionsForPool).filter(
      item => item.isAnsweredCorrectly === true
    );

    const countCorrectlyAnsweredQuestionsInSection = correctlyAnsweredQuestionsInSection.length;
    const countQuestionsInSection = questionsForPool.length;

    const shouldDisplayAsPassed = false;

    let courseStatusText;
    if (shouldSubmitAllQuestions) {
      courseStatusText = localize('[x y questions answered]', {
        countAnsweredQuestionsInSection: answeredPoolQuestionsCount,
        countQuestionsInSection
      });
    } else {
      courseStatusText = localize('[x y answered correctly]', {
        countCorrectlyAnsweredQuestionsInSection,
        countQuestionsInSection
      });
    }

    return (
      <SectionItem role="presentation">
        <Header
          ariaLabel={`${localize('[close section items]')} ${title}`}
          tabIndex={0}
          role="menuitem"
          ariaExpanded={true}
          aria-haspopup={true}
          onClick={this.toggleIsExpanded}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              this.toggleIsExpanded();
            }
          }}
        >
          <SectionText appearance="h4" maxLength={35}>
            {title}
          </SectionText>
        </Header>
        <Collapse isExpanded={true} animateAppear={false} duration={200} opacityDuration="200">
          <QuestionList role="menu">{children}</QuestionList>
        </Collapse>
        <Footer>
          <StatusText
            isPassed={shouldDisplayAsPassed}
            ariaLabel={`${localize('[aria label status text]')} ${title}`}
            tabIndex={-1}
            role="status"
            isOverallMasteryScore={isCourseProgress}
          >
            {courseStatusText}
          </StatusText>
        </Footer>
      </SectionItem>
    );
  }
}
